import React from 'react';
import PropTypes from 'prop-types';
import ConnectedVerifyForm from './ConnectedVerifyForm';

const VerifyRouting = ({ match }) => <ConnectedVerifyForm />;

VerifyRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default VerifyRouting;
